module.exports = __webpack_public_path__ + "static/media/core-values.3082f0df.jpg";